import { combineReducers } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import apiReducer from "./api.reducer";
import authReducer from "./auth.reducer";
import garageReducer from "./garage.reducer";
import loaderReducer from "./loader.reducer";
import modalReducer from "./modal.reducer";
import shoppingCartReducer from "./shopping-cart.reducer";
import utilsReducer from "./utils.reducer";

const combinedReducer = combineReducers({
  garage: garageReducer,
  authenticationState: authReducer,
  modal: modalReducer,
  shoppingCart: shoppingCartReducer,
  loader: loaderReducer,
  utils: utilsReducer,
  apiReducer,
});

const rootReducer: typeof combinedReducer = (state, action) => {
  if (action.type === HYDRATE) {
    const {
      garage, utils, authenticationState,
    } = action.payload;
    const { garage: clientGarage, utils: clientUtils, authenticationState: clientAuthenticationState } = state;
    /*  Preserve values on client side navigation.
        By default, HYDRATE will take store values from getServerSideProps or getStaticProps and set on every client side render.
        i.e. initialState + dispatches in getServerSideProps or getStaticProps. The reducer must merge the existing client state properly
        Override only the values that need to be updated in SSR
    */
    const nextState = {
      ...state, // use previous state
      garage: {
        ...clientGarage,
        selectedVehicle: clientGarage.selectedVehicle ?? garage.selectedVehicle,
      },
      utils: {
        ...clientUtils,
        width: clientUtils.width > 0 ? clientUtils.width : utils.width,
        currentPageType: utils.currentPageType,
        previousPageType: clientUtils.currentPageType,
        urlInformation: utils.urlInformation ?? clientUtils.urlInformation,
      },
      authenticationState: {
        ...clientAuthenticationState,
        averageRating: authenticationState.averageRating,
        totalReviewCount: authenticationState.totalReviewCount,
      },
    };
    return nextState;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
